module.exports = __webpack_public_path__ + "static/img/33.a17745c2.png";